export class SavePendingAppRequest {
    appId: string;
    companyName: string;
    employeeCount: number;
    businessPhone: string;
    businessAddress: string;
    businessCity: string;
    businessState: string;
    businessZip: string;
    minorityCerts: number[];
    liaisonFirstName: string;
    liaisonLastName: string;
    liaisonEmail: string;
    liaisonPhone: string;
    liaisonTitle: string;
    membershipLevel: number;
    price: number;
    paymentType: number;
    isAutoRenew: boolean;
    overridePayment: boolean = false;
    cardNumber: string;
    cardExpiration: string;
    cvv: string;

    routingNumber: string;
    accountNumber1: string;
    accountNumber2: string;
    constructor(appId: string,
        companyName: string,
        employeeCount: number,
        businessPhone: string,
        businessAddress: string,
        businessCity: string,
        businessState: string,
        businessZip: string,
        minorityCerts: number[],
        liaisonFirstName: string,
        liaisonLastName: string,
        liaisonEmail: string,
        liaisonPhone: string,
        liaisonTitle: string,
        membershipLevel: number,
        price: number,
        paymentType: number,
        isAutoRenew: boolean,
    ) {
        this.appId = appId;
        this.companyName = companyName;
        this.employeeCount = employeeCount;
        this.businessPhone = businessPhone;
        this.businessAddress = businessAddress;
        this.businessCity = businessCity;
        this.businessState = businessState;
        this.businessZip = businessZip;
        this.minorityCerts = minorityCerts;
        this.liaisonFirstName = liaisonFirstName;
        this.liaisonLastName = liaisonLastName;
        this.liaisonEmail = liaisonEmail;
        this.liaisonPhone = liaisonPhone;
        this.liaisonTitle = liaisonTitle;
        this.membershipLevel = membershipLevel;
        this.price = price;
        this.paymentType = paymentType;
        this.isAutoRenew = isAutoRenew;
    }
}